// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1608) return "static/chunks/1608-2ac4230525bc875a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5382 ? "3ca81809" : chunkId) + "." + {"1951":"2e0f04ced1bea4f3","5382":"5e2d79abdd608a6a"}[chunkId] + ".js";
};